import baseRequest from '../baseRequest';
import AppConfig   from '../../app/config/AppConfig';
import {addPopup, setSMS} from '../../redux/actions';
import * as popups from "../../constants/popup-types";

class sendOrderSMS extends baseRequest{

    constructor() {
        super();
        this.dispatch = null;
        this.response = null;
        this.name     = 'send Order SMS';
        this.Config   = new AppConfig();
    }

    execute(dispatch,payload) {
        this.dispatch = dispatch;
        this.call(this.Config.api.requests.sendOrderSMS, payload);
    }

    //Parse successful response
    //Response failure is handled in parent class: baseRequest
    onSuccess() {
        this.updateState();
    }

    //update redux store
    updateState() {
        this.dispatch(setSMS(true));
    }


    onFailure(response, methodName = '') {
        this.dispatch(addPopup({
            type:popups.GENERAL_MESSAGE,
            text: response.err.content,
            popup_id: Math.round(Math.random() * 1000000)
        }));
    }

}
export default sendOrderSMS;